import { createReducer } from 'redux-act'
import u from 'updeep'

import { receive } from 'actions/locales'

const initialState = {}

export default createReducer({
  [receive]: (state, { locale, messages }) => {
    return u({ [locale]: messages }, state)
  },
}, initialState)
